export const scrollToAnchor = (
  anchor: string,
  delay: number = 1000
): (() => void) => {
  const observer = new MutationObserver(() => {
    const element = document.getElementById(anchor);

    if (element) {
      const timeoutId = setTimeout(() => {
        element.scrollIntoView({ behavior: 'smooth' });
        observer.disconnect();
      }, delay);

      return () => clearTimeout(timeoutId);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  return () => observer.disconnect();
};
